var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { createAsyncThunk } from '@reduxjs/toolkit';
import { dealSelector } from './selectors';
import { isTooEarlyToUpdateRecentFailure, shouldFetch } from '../../reducers/factory';
import { DEALS_FETCH_TIMEOUT, DEALS_MIN_UPDATE } from './consts';
import { NOOP } from '../../utils';
import { authSelector } from '../../selectors';
import { claimDealOffer, fetchDealByAliasOrId } from '../../api/deals';
import { DEFAULT_FETCH_STATUS } from '../../utils/fetchStatus';
export var fetchDeal = createAsyncThunk('deals/fetchByAliasOrId', function (idOrAlias, _a) {
    var getState = _a.getState, rejectWithValue = _a.rejectWithValue, fulfillWithValue = _a.fulfillWithValue;
    return __awaiter(void 0, void 0, void 0, function () {
        var _b, apiUrl, token, deal;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _b = authSelector(getState()), apiUrl = _b.apiUrl, token = _b.token;
                    if (!apiUrl) {
                        return [2 /*return*/, rejectWithValue(undefined, idOrAlias)];
                    }
                    return [4 /*yield*/, fetchDealByAliasOrId(apiUrl, token, idOrAlias)];
                case 1:
                    deal = _c.sent();
                    return [2 /*return*/, fulfillWithValue(deal, idOrAlias)];
            }
        });
    });
}, {
    getPendingMeta: function (_a) {
        var idOrAlias = _a.arg;
        return idOrAlias;
    },
});
export var fetchDealIfNeeded = function (idOrAlias) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, deal, fetchStatus, shouldRefetch;
    var _b;
    return __generator(this, function (_c) {
        _a = (_b = dealSelector(getState(), idOrAlias)) !== null && _b !== void 0 ? _b : __assign({}, DEFAULT_FETCH_STATUS), deal = _a.deal, fetchStatus = __rest(_a, ["deal"]);
        shouldRefetch = shouldFetch({
            fetchStatus: fetchStatus,
            fetchTimeout: DEALS_FETCH_TIMEOUT,
            minUpdate: DEALS_MIN_UPDATE,
        });
        if (shouldRefetch) {
            return [2 /*return*/, dispatch(fetchDeal(idOrAlias)).unwrap().then(NOOP)];
        }
        return [2 /*return*/, isTooEarlyToUpdateRecentFailure(fetchStatus)
                ? Promise.reject()
                : Promise.resolve()];
    });
}); }; };
export var claimOffer = createAsyncThunk('deals/claimOffer', function (offerId, _a) {
    var getState = _a.getState, rejectWithValue = _a.rejectWithValue;
    var _b = authSelector(getState()), apiUrl = _b.apiUrl, token = _b.token;
    if (!apiUrl || !token) {
        return rejectWithValue(undefined);
    }
    return claimDealOffer(apiUrl, token, offerId);
});
